import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.scss';
const TextArea = ({ label, name, value, onChange }) => {
    return (_jsxs(_Fragment, { children: [(label === null || label === void 0 ? void 0 : label.length) && (_jsxs(_Fragment, { children: [_jsx("label", Object.assign({ style: { fontWeight: 'bold', color: '#454545' } }, { children: label })), _jsx("br", {})] })), _jsx("textarea", { onChange: onChange, value: value, className: styles.textarea, name: name })] }));
};
export default TextArea;
